import axios from '../axiosClient';

export const getAmountRegister = () => axios.get('/invoicing/bill_label/register');

export const getInvoice = (idAyomi: number) => axios.get(`/invoicing/generate_pdf/${idAyomi}/set_up`, {
  responseType: 'blob',
  headers: {
    Accept: 'application/octet-stream',
  },
});
